enum TipoEnvioMensagemEnum {
  Nenhum = 'Nenhum',
  Abrir = 'Abrir',
  Enviar = 'Enviar'
}

export default TipoEnvioMensagemEnum
